import React, { useEffect, useState } from "react";
import "./ComingSoon.css";
import { NavLink } from "react-router-dom";
import logo from "../../images/croped logo-2.png";
const ComingSoon = () => {
    const launchDate = new Date(
        Date.now() + 20 * 24 * 60 * 60 * 1000
      );
  const [timeLeft, setTimeLeft] = useState({});

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const diff = launchDate - now;

      if (diff <= 0) {
        clearInterval(timer);
        setTimeLeft({});
        return;
      }

      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60),
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="coming-soon">
      <div className="overlay">
              {/* Logo */}
              <NavLink to="/" className="logo">
  <img src={logo} alt="PUJO Logo" className="logo-img" />
</NavLink>

        <h1>🚀 Coming Soon</h1>
        <p>We’re working hard to launch something amazing.</p>

        <div className="countdown">
          {Object.keys(timeLeft).length > 0 ? (
            <>
              <TimeBox label="Days" value={timeLeft.days} />
              <TimeBox label="Hours" value={timeLeft.hours} />
              <TimeBox label="Minutes" value={timeLeft.minutes} />
              <TimeBox label="Seconds" value={timeLeft.seconds} />
            </>
          ) : (
            <h2>We are live!</h2>
          )}
        </div>

        {/* <form className="notify-form">
          <input type="email" placeholder="Enter your email" />
          <button type="button">Notify Me</button>
        </form> */}
      </div>
    </div>
  );
};

const TimeBox = ({ label, value }) => (
  <div className="time-box">
    <span className="time">{value}</span>
    <span className="label">{label}</span>
  </div>
);

export default ComingSoon;
